import { createFileRoute } from '@tanstack/react-router'

import { CustomerDashboard } from '@/components/Customer/Dashboard'

export const Route = createFileRoute(
  '/internal/customer-view/$userId/dashboard',
)({
  component: CustomerDashboard,
})
